module.exports = "pegasus_template/assets/themecapture1/small/logo.png";